if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        console.log('🟢 ProductForm initialized');
        
        // Wait for DOM to be fully ready before initializing bundle controls
        setTimeout(() => {
          this.initializeBundleControls();
        }, 100);
      }

      initializeBundleControls() {
        const bundleCheckboxes = document.querySelectorAll('.bundle-item-checkbox');
        
        if (bundleCheckboxes.length === 0) {
          console.log('⚠️ No bundle controls found');
          return;
        }

        console.log('🎯 Initializing bundle controls');

        // Set initial state
        this.updateBundleSelection();

        // Listen to variant radio changes with multiple methods
        const variantFieldset = document.querySelector('fieldset.product-form__input--pill');
        
        if (variantFieldset) {
          // Method 1: Direct event listeners on radio buttons
          const variantRadios = variantFieldset.querySelectorAll('input[type="radio"]');
          variantRadios.forEach(radio => {
            radio.addEventListener('change', () => {
              console.log('🔄 Variant changed via radio:', radio.value);
              this.updateBundleSelection();
            });
            radio.addEventListener('click', () => {
              console.log('🖱️ Variant clicked:', radio.value);
              this.updateBundleSelection();
            });
          });

          // Method 2: Event delegation on fieldset
          variantFieldset.addEventListener('change', (e) => {
            if (e.target.type === 'radio') {
              console.log('🔄 Variant changed via delegation:', e.target.value);
              this.updateBundleSelection();
            }
          });

          // Method 3: MutationObserver for checked attribute changes
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
                console.log('🔍 Variant checked state changed');
                this.updateBundleSelection();
              }
            });
          });

          variantRadios.forEach(radio => {
            observer.observe(radio, { attributes: true });
          });
        }

        // Listen to checkbox changes
        bundleCheckboxes.forEach(checkbox => {
          checkbox.addEventListener('change', () => this.handleBundleCheckboxChange());
          checkbox.addEventListener('click', () => {
            setTimeout(() => this.handleBundleCheckboxChange(), 10);
          });
        });

        console.log('✅ Bundle controls initialized');
      }

      getMaxItemsForVariant(variantValue) {
        // Map variant names to their required item counts
        const variantMap = {
          'duo': 2,
          'trio': 3,
          'five': 5
        };
        
        return variantMap[variantValue] || 2; // Default to 2 if not found
      }

      updateBundleSelection() {
        const selectedVariant = document.querySelector('input[name="Packs-2"]:checked') || 
                               document.querySelector('fieldset.product-form__input--pill input[type="radio"]:checked');
        const bundleCheckboxes = document.querySelectorAll('.bundle-item-checkbox');
        
        if (!selectedVariant || bundleCheckboxes.length === 0) {
          console.log('⚠️ No variant or checkboxes found');
          return;
        }
        
        const variantValue = selectedVariant.value.toLowerCase();
        const maxItems = this.getMaxItemsForVariant(variantValue);
        
        console.log('📦 Updating bundle for variant:', variantValue, '- Max items:', maxItems);

        // Reset all checkboxes first - make them all ENABLED
        bundleCheckboxes.forEach((checkbox) => {
          checkbox.disabled = false;
          checkbox.parentElement.style.opacity = '1';
          checkbox.parentElement.style.pointerEvents = 'auto';
        });

        // Auto-select items based on max count
        bundleCheckboxes.forEach((checkbox, index) => {
          if (index < maxItems) {
            checkbox.checked = true;
          } else {
            checkbox.checked = false;
          }
        });

        console.log('✅ Auto-selected first', maxItems, 'items for', variantValue);
        
        // Update visual state
        this.handleBundleCheckboxChange();
      }

      handleBundleCheckboxChange() {
        const selectedVariant = document.querySelector('input[name="Packs-2"]:checked') || 
                               document.querySelector('fieldset.product-form__input--pill input[type="radio"]:checked');
        
        if (!selectedVariant) return;
        
        const variantValue = selectedVariant.value.toLowerCase();
        const maxItems = this.getMaxItemsForVariant(variantValue);
        
        const bundleCheckboxes = document.querySelectorAll('.bundle-item-checkbox');
        const checkedBoxes = Array.from(document.querySelectorAll('.bundle-item-checkbox:checked'));
        
        console.log('📊 Current state - Checked:', checkedBoxes.length, '/ Max:', maxItems);
        
        // If more than max are checked, uncheck the extras
        if (checkedBoxes.length > maxItems) {
          // Uncheck items beyond the limit
          for (let i = maxItems; i < checkedBoxes.length; i++) {
            checkedBoxes[i].checked = false;
          }
          console.log('⚠️ Unchecked excess items - limit is', maxItems);
        }

        // Update visual feedback - dim items when limit reached
        const currentChecked = document.querySelectorAll('.bundle-item-checkbox:checked').length;
        const limitReached = currentChecked >= maxItems;
        
        bundleCheckboxes.forEach((checkbox) => {
          // Keep all enabled, just change opacity for visual feedback
          checkbox.disabled = false;
          
          if (limitReached && !checkbox.checked) {
            checkbox.parentElement.style.opacity = '0.5';
            checkbox.parentElement.style.cursor = 'not-allowed';
          } else {
            checkbox.parentElement.style.opacity = '1';
            checkbox.parentElement.style.cursor = 'pointer';
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log('🔵 Form submission started');
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          console.log('⚠️ Submit button is disabled, returning');
          return;
        }

        this.handleErrorMessage();

        // Validate bundle selection
        if (!this.validateBundleSelection()) {
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const selectedBundleItems = this.getSelectedBundleItems();
        console.log('📦 Selected bundle items:', selectedBundleItems);
        
        if (selectedBundleItems.length > 0) {
          console.log('🎯 Bundle product with selected items');
          this.addBundleToCart(evt, selectedBundleItems);
        } else {
          console.log('📦 Regular product (no bundle items selected)');
          this.addRegularToCart(evt);
        }
      }

      validateBundleSelection() {
        const bundleContainer = document.querySelector('.bundle-products');
        
        if (!bundleContainer) {
          return true;
        }

        const selectedVariant = document.querySelector('input[name="Packs-2"]:checked') || 
                               document.querySelector('fieldset.product-form__input--pill input[type="radio"]:checked');
        
        if (!selectedVariant) {
          this.handleErrorMessage('Please select a pack option');
          return false;
        }

        const variantValue = selectedVariant.value.toLowerCase();
        const requiredItems = this.getMaxItemsForVariant(variantValue);
        const checkedItems = document.querySelectorAll('.bundle-item-checkbox:checked').length;

        console.log('🔍 Validation:', { 
          variant: variantValue, 
          required: requiredItems, 
          checked: checkedItems 
        });

        if (checkedItems !== requiredItems) {
          const errorMsg = `Please select exactly ${requiredItems} bundle items for ${selectedVariant.value}`;
          console.error('❌', errorMsg);
          this.handleErrorMessage(errorMsg);
          
          if (this.errorMessageWrapper) {
            this.errorMessageWrapper.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'center' 
            });
          }
          
          return false;
        }

        return true;
      }

      getSelectedBundleItems() {
        console.log('🔍 Looking for selected bundle items...');
        const bundleContainer = document.querySelector('.bundle-products');
        
        if (!bundleContainer) {
          console.log('⚠️ No .bundle-products container found');
          return [];
        }
        
        const selectedItems = [];
        const checkboxes = bundleContainer.querySelectorAll('.bundle-item-checkbox:checked');
        
        console.log('📋 Checked items found:', checkboxes.length);
        
        checkboxes.forEach((checkbox, index) => {
          const title = checkbox.value;
          const variantId = checkbox.dataset.variantId;
          
          console.log(`  Item ${index + 1}:`, {
            title: title,
            variantId: variantId
          });
          
          if (title && variantId) {
            selectedItems.push({
              title: title,
              variantId: variantId
            });
          }
        });
        
        console.log('✅ Total selected bundle items:', selectedItems.length);
        return selectedItems;
      }

      addBundleToCart(evt, selectedBundleItems) {
        console.log('🎁 Adding product with bundle properties...');
        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const quantity = parseInt(formData.get('quantity') || 1);
        
        console.log('Main product quantity:', quantity);

        selectedBundleItems.forEach((item, index) => {
          const propKey = `properties[Bundle Item ${index + 1}]`;
          const propValue = `${item.title} x ${quantity}`;
          formData.append(propKey, propValue);
          console.log(`Added property: ${propKey} = ${propValue}`);
        });
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        console.log('🚀 Sending to cart...');

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            console.log('Cart add response status:', response.status);
            return response.json();
          })
          .then((response) => {
            console.log('Cart add response data:', response);
            
            if (response.status) {
              console.error('❌ Cart error:', response);
              
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              console.log('No cart element, redirecting to cart page');
              window.location = window.routes.cart_url;
              return;
            }

            console.log('✅ Product with bundle properties added successfully');

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error('❌ Fetch error:', e);
          })
          .finally(() => {
            console.log('🏁 Bundle add to cart completed');
            
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      addRegularToCart(evt) {
        console.log('📦 Adding regular product to cart...');
        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        console.log('Form data:', {
          id: formData.get('id'),
          quantity: formData.get('quantity')
        });
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        console.log('🚀 Fetching cart add URL...');

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            console.log('Cart add response status:', response.status);
            return response.json();
          })
          .then((response) => {
            console.log('Cart add response data:', response);
            
            if (response.status) {
              console.error('❌ Cart error:', response);
              
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              console.log('No cart element, redirecting to cart page');
              window.location = window.routes.cart_url;
              return;
            }

            console.log('✅ Product added successfully');

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error('❌ Fetch error:', e);
          })
          .finally(() => {
            console.log('🏁 Regular add to cart completed');
            
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          console.log('⚠️ Error message displayed:', errorMessage);
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
  
  console.log('✅ ProductForm custom element registered');
}